// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/typographyStyle
import { container } from 'styles/jss/original/base';

const styles = {
  container,
  textQuote: {
    paddingBottom: '10px'
  }
};

export default styles;
